
// Selected from data using Rainbow CSV extension for VSCode with:
// SELECT parseFloat(a2).toFixed(3), parseFloat(a3).toFixed(3), Math.round(parseFloat(a5)), Math.round(parseFloat(a6))

import { RawBatteryPlantData } from "./interface"


export const battery_plants_data: RawBatteryPlantData[] = [
[53.531,-2.166,20,20],
[53.902,-0.825,200,400],
[55.025,-1.503,25,13],
[51.938,0.120,50,50],
[51.707,-3.585,22,33],
[51.312,1.343,100,100],
[52.826,-1.072,20,28],
[51.485,-2.572,15,22],
[51.595,0.486,15,33],
[51.625,-3.897,20,22],
[51.625,-3.823,20,22],
[55.003,-1.483,17,20],
[51.743,-3.541,22,52],
[53.364,-0.796,49,25],
[51.230,-0.355,6,6],
[51.608,-1.998,50,50],
[52.725,-1.448,10,12],
[53.025,-0.585,7,7],
[51.552,-1.814,50,75],
[53.800,-0.411,98,196],
[51.315,0.462,29,29],
[51.528,-2.661,32,32],
[56.565,-2.620,35,35],
[50.955,-0.163,34,68],
[51.014,-2.208,20,40],
[50.942,-1.485,50,53],
[51.710,-1.190,52,55],
[52.553,-1.957,50,100],
[52.599,-1.223,50,50],
[52.188,1.366,50,74],
[51.367,0.742,50,50],
[55.907,-3.588,30,30],
[55.769,-3.939,50,100],
[57.516,-2.943,200,400],
[51.040,-1.370,19,38],
[51.414,0.327,11,22],
[51.927,-0.496,50,99],
[51.552,0.298,99,198],
[51.189,-0.829,20,40],
[57.221,-2.370,50,50],
[56.480,-3.013,50,50],
[56.109,-3.266,50,50],
[53.501,-1.116,10,10],
[51.735,-0.237,49,99],
[51.392,-2.156,100,100],
[53.266,-2.944,100,107],
[51.641,0.358,10,10],
[56.110,-3.271,50,99],
[54.546,-1.559,0,5],
[54.075,-1.523,33,66],
[55.577,-4.467,300,600],
[53.456,-2.066,42,104],
[55.903,-4.480,40,80],
[53.733,-0.989,100,200],
[56.208,-3.204,50,100],
[52.073,1.065,57,114],
[51.866,0.574,57,144],
[54.807,-1.400,50,100],
[53.550,-1.449,40,120],
[53.996,-0.413,30,60],
[53.754,-1.265,57,165],
[52.540,-2.031,57,165],
[53.268,-2.950,57,165],
[53.265,-2.945,57,138],
[55.786,-4.196,50,100],
[53.807,-2.210,70,163],
[51.576,-2.475,50,99],
[56.538,-3.271,40,80],
[52.600,-1.216,57,57],
[51.547,-2.968,230,460],
[53.607,-0.183,80,160],
[51.612,-0.690,40,60],
[51.566,-2.967,20,50],
[53.502,-1.380,50,102],
[57.128,-4.727,50,100],
[53.849,-3.026,25,50],
[50.726,-1.990,8,15],
[51.578,-0.531,20,20],
[53.562,-2.807,50,100],
[51.601,-1.749,30,60],
[50.487,-3.544,22,44],
[53.756,-2.445,25,50],
[53.416,-2.133,50,100],
[53.419,-2.136,35,70],
[53.416,-2.136,20,40],
[53.721,-1.276,150,300],
[51.933,-0.499,50,100],
[51.608,-1.997,50,50],
[57.406,-2.518,50,110],
[55.915,-3.461,50,100],
[50.397,-4.899,50,100],
[50.393,-4.902,48,102],
[51.334,-1.071,100,331],
[52.537,-1.714,400,1424],
[52.383,-1.618,200,712],
[51.291,-2.470,6,12],
[51.378,-2.100,50,100],
[53.616,-2.692,30,60],
[53.748,-2.759,50,100],
[54.975,-1.741,78,156],
[53.951,-0.403,8,16],
[51.683,-2.419,50,58],
[51.568,-2.478,120,300],
]
